import { type TrackedEvent } from '../../../utils/events/trackEvent'

export const getNavigationActionEventDataV3 = (
  href: string | undefined,
  route: string | undefined
): TrackedEvent => ({
  id: 'navV3.navigation.action',
  description: 'User clicked to navigate',
  data: { href, route },
})

export const getNavVersionDailyEventData = (version: 'v2' | 'v3'): TrackedEvent => ({
  id: 'app.navVersion.daily',
  description: 'Daily snapshot of which nav version the user is rendering',
  data: { version },
})

export type NavVersionSwitchSource = 'switcherButton' | 'onboardingDismiss'

export const getNavVersionSwitchedEventData = (
  from: 'v2' | 'v3',
  to: 'v2' | 'v3',
  source: NavVersionSwitchSource
): TrackedEvent => ({
  id: 'app.navVersion.switched',
  description: 'User switched between nav v2 and v3',
  data: { from, to, source },
})
